(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/filter-and-sort/assets/javascripts/components/filter-option.js') >= 0) return;  svs.modules.push('/components/casino-react/filter-and-sort/assets/javascripts/components/filter-option.js');

'use strict';

const Checkbox = svs.ui.ReactForm.Checkbox;
const useSetSearchParams = svs.components.casino_react.hooks.useSetSearchParams;
const FilterOption = _ref => {
  let filterOption = _ref.filterOption,
    filterType = _ref.filterType,
    checked = _ref.checked;
  const _useSetSearchParams = useSetSearchParams(),
    setFilter = _useSetSearchParams.setFilter;
  return React.createElement("li", {
    className: "filter-option"
  }, React.createElement(Checkbox, {
    branding: "inverted",
    checked: checked,
    onChange: event => {
      event.stopPropagation();
      setFilter({
        checked: event.target.checked,
        type: filterType,
        name: filterOption.title
      });
      if (!checked) {
        svs.components.casino.shared.trackEvent('Checked', 'Filter', filterOption.title);
      }
    },
    value: filterOption.title
  }, filterOption.title));
};
setGlobal('svs.components.casino_react.filterAndSort.components.FilterOption', FilterOption);

 })(window);